{
  "title": "My profile",
  "subtitle": "Your name, your language, your password and your alert emails.",
  "saved": "Profile saved",
  "personal": {
    "title": "About you"
  },
  "role": "Role",
  "workplaces": "Can work in",
  "lastSignIn": "Last sign-in",
  "allLocations": "All locations",
  "languageHint": "The interface switches to this language on every device you use.",
  "fields": {
    "fullName": "Full name",
    "language": "Language"
  },
  "password": {
    "title": "Password",
    "subtitle": "Changing it signs you out of your other devices."
  },
  "notifications": {
    "title": "Alert notifications",
    "subtitle": "New alerts always show up on the bell. Choose what you also receive by email.",
    "email": "Email for each alert",
    "emailText": "A short email when an alert about your locations is raised.",
    "digest": "Daily summary email",
    "digestText": "Once a day, the alerts that are still open.",
    "noEmail": "You have no email address yet. Ask an administrator to add one to your account.",
    "saved": "Notification settings saved"
  }
}
